/* eslint-disable no-bitwise */

import { doesPermissionAutoEnableOthers } from './folderPermissionHelper';

//The power should be one less than the value in the GroupPermissionOperation enum
//defined in Core.Entities.Group
//the idea is that we want the nth bit set if the value in the enum is n
//This only works if the values in the enum are less than 32 which they are for now
//We have to subtract 1 in the exponent since the first bit is the zeroth power of 2
// eslint-disable-next-line no-restricted-properties
const _getValueForEnum = (e) => Math.pow(2, e - 1);

export const VIEW_REPORTS = _getValueForEnum(11);
export const MANAGE_TEMPLATES = _getValueForEnum(13);
export const PUBLIC_SHARE = _getValueForEnum(14);
export const FORM_COPY = _getValueForEnum(15);
export const FORM_RENAME = _getValueForEnum(16);
export const FORM_TRANSFER = _getValueForEnum(17);
export const FORM_DELETE = _getValueForEnum(18);
export const FORM_EDIT = _getValueForEnum(19);
export const FORM_COMPLETE = _getValueForEnum(20);
export const FORM_DELETE_DRAFTS = _getValueForEnum(21);
export const FORM_PDF = _getValueForEnum(22);
export const FORM_TAGS = _getValueForEnum(23);
export const TAG_CREATE = _getValueForEnum(24);
export const TAG_MANAGE = _getValueForEnum(25);
export const MANAGE_DATASOURCES = _getValueForEnum(26);
export const MANAGE_WORKFLOWS = _getValueForEnum(27);
export const MANAGE_USERS_GROUPS = _getValueForEnum(28);
export const ALL_FORM_PERMISSIONS =
  FORM_COPY | FORM_RENAME | FORM_TRANSFER | FORM_DELETE | FORM_EDIT | FORM_COMPLETE | FORM_DELETE_DRAFTS | FORM_PDF | FORM_TAGS;
export const ALL_MANAGE_PERMISSIONS =
  MANAGE_TEMPLATES | MANAGE_DATASOURCES | VIEW_REPORTS | PUBLIC_SHARE | MANAGE_WORKFLOWS | TAG_CREATE | TAG_MANAGE | MANAGE_USERS_GROUPS;

export const HasPermission = (permission: number, flag: number) => {
  /*
    doesPermissionAutoEnableOthers is a Fallback for new permissions where bitwise checks may not suffice:
    e.g., 3 (view all) & 4 (view members' forms) === 4 is false,
    but we still need to enable 'view members' forms' when 'view all' is on.

    This function checks if enabling one permission should automatically
    enable others, handling cases where simple bitwise operations
    don't capture the desired behavior.
    */
  return (permission & flag) === flag || doesPermissionAutoEnableOthers(flag, permission);
};

export const enum FOLDER_PERMISSIONS {
  FOLDER_VIEW = 1,
  FOLDER_VIEW_ALL = 2,
  FOLDER_VIEW_MEMBERS_FORMS = 4
}

//this might be a better approach
//https://gist.github.com/xmlking/e86e4f15ec32b12c4689
//doesn't have a license
//doesn't support flags (prob easy to add though)

//TODO make a decision when we need another enum.
